import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  spacing16,
  spacing12,
  spacing4,
} from 'approot/shared/styles/spacing.style';
import {
  grey2,
  grey5,
  grey6,
  grey8,
  red8,
} from 'approot/shared/styles/colours.style';
import { flexColumnCss } from 'approot/shared/styles/flex.style';

export const FileDropperImage = styled.div`
  ${flexColumnCss}
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(spacing12)};
  width: 100%;
`;

type FileDropperImageFieldProps = {
  $activeDrag?: boolean;
  $focus?: boolean;
  $isLoading?: boolean;
  $hasError?: boolean;
};

export const FileDropperImageField = styled.div<FileDropperImageFieldProps>`
  background-color: ${grey2};
  border: 1px dashed ${({ $hasError }) => ($hasError ? red8 : grey5)};
  border-radius: ${rem(borderRadius8)};
  color: ${grey8};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: ${rem(20)};
  padding: ${rem(spacing16)};
  outline: none;
  width: 100%;
  text-align: center;

  ${({ $activeDrag }) =>
    $activeDrag &&
    `
    opacity: 0.5;
  `};

  ${({ $focus }) =>
    $focus &&
    `
    border-color: ${red8};
    border-width: 2px;
  `}

  ${({ $isLoading }) =>
    $isLoading &&
    `
    cursor: not-allowed;
  `}
`;

export const FileDropperImagePlaceholder = styled.div`
  svg {
    margin-bottom: ${rem(spacing4)};

    path {
      fill: ${grey6};
    }
  }
`;
